import { render, staticRenderFns } from "./reservation-box.vue?vue&type=template&id=9f8aea90"
import script from "./reservation-box.vue?vue&type=script&lang=js"
export * from "./reservation-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports